<template lang="pug">
  .dialog-focus-lock
    slot
</template>

<script>
export default {
  name: 'FocusLock',

  data() {
    return {
      focusableEls: [],
      firstFocusableEl: [],
      lastFocusableEl: [],
      focusedElBeforeOpen: document.activeElement,
    };
  },

  mounted() {
    this.handleDialogFocusLock();
  },

  methods: {
    handleDialogFocusLock() {
      const selectors = ''
        + 'a[href], '
        + 'input:not([disabled]), '
        + 'select:not([disabled]), '
        + 'textarea:not([disabled]), '
        + 'button:not([disabled])';

      const getEls = this.$el.querySelectorAll(selectors);

      this.focusableEls = Array.prototype.slice.call(getEls);
      [this.firstFocusableEl] = this.focusableEls; // gets first array item
      [this.lastFocusableEl] = this.focusableEls.slice(-1); // gets last array item

      this.$el.addEventListener('keydown', e => this.handleKeyDown(e));

      // Uncomment below to focus first element
      // this.firstFocusableEl.focus();
    },

    handleBackwardTab(e) {
      if (document.activeElement === this.firstFocusableEl) {
        e.preventDefault();
        this.lastFocusableEl.focus();
      }
    },

    handleForwardTab(e) {
      if (document.activeElement === this.lastFocusableEl) {
        e.preventDefault();
        this.firstFocusableEl.focus();
      }
    },

    handleKeyDown(e) {
      const KEY_TAB = 9;

      switch (e.keyCode) {
        case KEY_TAB:
          if (this.focusableEls.length === 1) {
            e.preventDefault();
            break;
          }
          if (e.shiftKey) {
            this.handleBackwardTab(e);
          } else {
            this.handleForwardTab(e);
          }
          break;
        default:
          break;
      }
    },
  },
};
</script>
